<template>
  <div class="cnehl-main" :style="{ 
    'width': '100%',
    'height': '100%',
    'position': 'relative'}">
    <div class="delivery-type" :style="{
      'width': `${120 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${175 * zoomLevel}px`,
			'left': `${70 * zoomLevel}px`, }">
      {@Delivery Type}
    </div>
    <div class="B2B" :style="{
      'width': `${55 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${175 * zoomLevel}px`,
			'left': `${205 * zoomLevel}px`, }">
      {@B2B}
    </div>
    <div class="timbang" :style="{
      'width': `${70 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${175 * zoomLevel}px`,
			'left': `${288 * zoomLevel}px`, }">
      {@Timbang}
    </div>
    <div class="urgency" :style="{
      'width': `${70 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${175 * zoomLevel}px`,
			'left': `${380 * zoomLevel}px`, }">
      {@Urgency}
    </div>
    <div class="office-hour" :style="{
      'width': `${111 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${175 * zoomLevel}px`,
			'left': `${480 * zoomLevel}px`, }">
      {@Office Hours}
    </div>
    <div class="consignment-note" :style="{
      'width': `${120 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${175 * zoomLevel}px`,
			'left': `${600 * zoomLevel}px`, }">
      CONSIGNMENT NOTE
    </div>

    <div class="customer-status" :style="{
      'width': `${198 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${60 * zoomLevel}px`,
			'left': `${138 * zoomLevel}px`, }">
      {@Customer Status}
    </div>
    
    <div class="created-by" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${9 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${820 * zoomLevel}px`,
			'left': `${70 * zoomLevel}px`, }">
      CREATED BY {createdby}
    </div>
    <!-- Customer Status -->
    <div class="cust-status" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${170 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${195 * zoomLevel}px`,
			'left': `${40 * zoomLevel}px`, }">
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">PRINT TIME</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Print Date} - {Print Time}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">PRINT NO</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Print Count}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">PRINTED BY</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{UserID}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">CONTAINER NO</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Container No}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">SZTYPE/STATUS</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cont Size} {Cont Type} {Status}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">SEAL NO</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Seal No}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">VESSEL VOYAGE</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Vessel Name} {Vessel No}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">PORT CODE</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Ship Call No}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">JOB TYPE</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Job Type}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">HANDLING TYPE</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Handling Type Desc}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">CNTR REMARKS</div>
        <div class="colon" :style="{ 'padding': '0 20px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Remarks}</div>
      </div>
    </div>
    <div class="cust-status" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${170 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${195 * zoomLevel}px`,
			'left': `${400 * zoomLevel}px`, }">
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Consignment</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Consignment No}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">RefNo</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Request No}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Required Date</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{RequiredDate}-{Required Time}-{Req Time Desc}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Req Type</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{@ETA Date} {@ETA Time}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Container No</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{@Temperature}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">Size / Type</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{@Fumigation}</div>
      </div>
    </div>
    <!-- Customer Status -->
    <!-- From - To -->
    <div class="from-to" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${90 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${375 * zoomLevel}px`,
			'left': `${40 * zoomLevel}px`, }">
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">FROM</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
      <div class="pickup-company" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${15 * zoomLevel}px`,
			'left': `${0 * zoomLevel}px`, }">
      {Pickup Company}
    </div>
    <div class="pickup-add" :style="{
      'width': `${290 * zoomLevel}px`,
			'height': `${45 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${30 * zoomLevel}px`,
			'left': `${0 * zoomLevel}px`, }">
      {Pickup Add}
    </div>
    </div>
    <div class="from-to" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${90 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${375 * zoomLevel}px`,
			'left': `${400 * zoomLevel}px`, }">
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">TO</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Destination Code} {Transit2}</div>
      </div>
      <div class="sendto-company" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${15 * zoomLevel}px`,
			'left': `${0 * zoomLevel}px`, }">
      {SendTo Company}
      </div>
      <div class="sendto-add" :style="{
      'width': `${290 * zoomLevel}px`,
			'height': `${45 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${30 * zoomLevel}px`,
			'left': `${0 * zoomLevel}px`, }">
      {Destination Add}
      </div>
    </div>
    <!-- From - To -->
    <!-- Container -->
    <div class="cn-report-container" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${230 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${440 * zoomLevel}px`,
			'left': `${40 * zoomLevel}px`, }">
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">CONTACT</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Attn}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">PHONE NO.</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{@Pickup Tel}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">FAX NO.</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Fax}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">SHIP TO PARTY</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">BILL TO PARTY</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">CARGO DESC.</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Commodity}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">DROPOFF LOC.</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Drop Off}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">WEIGHT(KG)</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cont Weight}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">FORWARDER</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Frt Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">SHIPPING AGENT</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Ag Name}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">CNTR OPERATOR</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Operator}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">CUSTOMER RED.</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cust Ref}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">BOOKING REF. NO.</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Booking Ref No}</div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">ORDER REMARKS</div>
        <div class="colon" :style="{ 'padding': '0 30px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Remarks}</div>
      </div>
    </div>
    <div class="cn-report-container" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${230 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${440 * zoomLevel}px`,
			'left': `${400 * zoomLevel}px`, }">
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">CONTACT</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Attn}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">PHONE NO</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{@Dest Tel}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">FAX NO</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Dest Fax}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">PHONE NO</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu Phone1}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">PHONE NO</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cu Phone2}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">FINAL DESTINATION</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Final Dest}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">DISCHARGE PORT</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Discharge Port}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">M3</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Cont Measure}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">PHONE NO</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Frt Tel}</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">PHONE NO</div>
        <div class="colon" :style="{ 'padding': '0 35px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">{Ag Tel}</div>
      </div>
    </div>
    
    <!-- Container -->
    <!-- Driver-->
    <div class="driver" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${100 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${700 * zoomLevel}px`,
			'left': `${40 * zoomLevel}px`, }">
      <div class="driver-part" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${-15 * zoomLevel}px`,
			'left': `${0 * zoomLevel}px`, }">
      DRIVER'S PARTICULARS
      </div>
      <div class="cust-name" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">TOWHEAD ID</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">TRAILER ID</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">DRIVER NAME</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
      <div class="address" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthLeft * zoomLevel}px`, 'max-width': `${labelWidthLeft * zoomLevel}px`, 'white-space': 'nowrap' }">SIGNATURE</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
    </div>
    
    <div class="driver" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${100 * zoomLevel}px`,
			'font-size': `${fontSize * zoomLevel}px`,
			'position': 'absolute',
			'top': `${700 * zoomLevel}px`,
			'left': `${400 * zoomLevel}px`, }">
      <div class="acknowledgement" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${15 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${-15 * zoomLevel}px`,
			'left': `${0 * zoomLevel}px`, }">
      ACKNOWLEDGEMENT
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">CONTAINER</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }">ACCEPTED / REJECTED</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">____________________________________</div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">SIGNATURE/COMPANY STAMP</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">NAME</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
      <div class="consignment" :style="{ 'display': 'flex', 'align-items': 'center', 'padding-bottom': `${rowPadding * zoomLevel}px` }">
        <div class="label" :style="{ 'min-width': `${labelWidthRight * zoomLevel}px`, 'max-width': `${labelWidthRight * zoomLevel}px`, 'white-space': 'nowrap' }">DATE/TIME</div>
        <div class="colon" :style="{ 'padding': '0 5px' }">:</div>
        <div class="value" :style="{ 'width': '100%' }"></div>
      </div>
    <!-- Driver -->
    
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      labelWidthLeft: 60,
      labelWidthRight: 75,
      rowPadding: 0,
      fontSize: 10
    }
  },
  props: {
    data: { type: Object, default: function() { return {}; }},
    printData: { type: Object, default: function() { return {}; }},

    properties: { type: Object, default: function() { return null; }},
    zoomLevel: { type: Number, default: 1 },
    fontPtPx: { type: Number, default: 1 },
    print: { type: Boolean, default: false },
  },
  methods: {
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style scoped>
.cust-status { border: 1px solid gray; }
.cn-report-container { border: 1px solid gray; }
</style>